// extracted by mini-css-extract-plugin
export default {"advertCardPhoto":"c-a_hx","advertCardPhoto__image":"c-a_hy"};